import app from 'flarum/forum/app';
import Switch from 'flarum/common/components/Switch';
import icon from 'flarum/common/helpers/icon';
import Field from './Field';

export default class Radio extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'options',
            'other',
            'min',
            'max',
        ]);
    }

    configure() {
        return [
            this.optionsRule(),
            this.otherRule(),
            this.minMaxRules(),
        ];
    }

    fill(display: boolean = false) {
        return this.choiceView((checked, onchange, disabled, key, children) => {
            const style = app.forum.attribute<string>('formulaireCheckboxStyle');

            const isFA = style && style.substr(0, 2) === 'fa';

            if (style === 'switch') {
                return Switch.component({
                    state: checked,
                    onchange,
                    disabled,
                }, children);
            }
            return m('label', {
                className: isFA ? 'FormulaireFAControl' : undefined,
            }, [
                m('input', {
                    type: 'checkbox',
                    checked,
                    onchange,
                    disabled,
                }),
                // The FontAwesome style will be called one of `fas-square`, `fas-circle`, `far-square`, `far-circle`
                isFA ? icon('fa' + style.substr(2, 1) + ' fa-' + (checked ? 'check-' : '') + style.substr(4)) : null,
                children,
            ]);
        }, display);
    }

    display() {
        return this.fill(true);
    }
}
